export const ONLY_NULL = "ONLY_NULL";
export const ONLY_NOT_NULL = "ONLY_NOT_NULL";
